import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Observable, Subject} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {FieldUiDataObj} from '../../../../../generated/generated-core.model';
import {MxCustomizable} from '../../../../mx-customizer';
import {MxFieldConfig} from '../../modules/mx-dynamic-fields/services/mx-field-customizer.service';
import {MxFormCustomizerEvent, MxFormFieldsBuilderService, MxFormMode} from '../../services/mx-form-fields-builder.service';

@Component({
    selector: 'mx-form',
    standalone: false,
    templateUrl: './mx-form.component.html',
    styleUrls: ['./mx-form.component.scss'],
    providers: [MxFormFieldsBuilderService]
})
export class MxFormComponent implements OnInit, MxCustomizable<MxFormCustomizerEvent> {
    @Input() formMode: MxFormMode;

    @Input() layoutClass: string;

    @Output() customize: EventEmitter<MxFormCustomizerEvent> = new EventEmitter<MxFormCustomizerEvent>();

    public form$: Observable<FormGroup>;
    public fields$: Observable<Array<FieldUiDataObj>>;
    public fieldConfigs: Map<string, MxFieldConfig>;
    public showErrorMessage: boolean = true;

    private _destroy$$: Subject<null> = new Subject<null>();

    /**
     * if false, form fields with showInCompactMode === false should be visible
     */
    public showOnlyCompactModeFields: boolean = true;
    public showDivider: boolean = false;

    constructor(public formFieldsBuilderService: MxFormFieldsBuilderService) {
    }

    ngOnInit(): void {
        let customizer: MxFormCustomizerEvent = new MxFormCustomizerEvent();
        this.customize.emit(customizer);
        if (typeof customizer.getProps().showErrorMessage === 'boolean') {
            this.showErrorMessage = customizer.getProps().showErrorMessage;
        }
        this.fieldConfigs = customizer.fieldConfigs;
        this.formFieldsBuilderService.buildForm(this.formMode, customizer);
        this.form$ = this.formFieldsBuilderService.getForm();
        this.fields$ = this.formFieldsBuilderService.getFields()
            .pipe(
                tap((fields: Array<FieldUiDataObj>) => {
                    if (fields && fields.length > 0) {
                        let compactModeFields = fields.filter((item) => item.showInCompactMode);
                        this.showDivider = fields.length > compactModeFields.length;
                    }
                })
            );
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }

    isFormNotValid(): Observable<boolean> {
        return this.form$
            .pipe(
                map((fg: FormGroup) => !fg.valid));
    }

    public toggleFullMode(): void {
        this.showOnlyCompactModeFields = !this.showOnlyCompactModeFields;
    }
}
